/*
 *  (c) 2015 - 2022 ENISCO by FORCAM GmbH
 */

import {App, AppId} from '../../model/apps'
import {Favorite} from '../../model/favorites'
import {clone} from '@enisco/mcc-react-lib'

const appIdConverter = (
  allAppIds: AppId[],
  registeredApps: App[],
  registeredFavorites: Favorite[]
) => {
  const apps: App[] = []
  if (allAppIds) {
    allAppIds.forEach((app) => {
      const fApp = registeredApps.find(
        (rApp) => rApp.app === app.app && rApp.module === app.module
      )
      if (fApp) {
        if (app.favoriteId) {
          const favorite = registeredFavorites.find(
            (fav) => fav.id === app.favoriteId
          )
          if (favorite) {
            const favoriteApp = clone(fApp)
            favoriteApp.description = favorite.description
            favoriteApp.favoriteId = favorite.id
            apps.push(favoriteApp)
          }
        } else {
          apps.push(fApp)
        }
      }
    })
  }
  return apps
}

export default appIdConverter
